import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateMemberBusinessUnitsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountMemberBusinessUnitsInput;
}>;

export type UpdateMemberBusinessUnitsMutationResult = { __typename?: 'Mutation' } & {
  updateAccountMemberBusinessUnits?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountMemberBusinessUnitsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateMemberBusinessUnitsDocument = gql`
  mutation updateMemberBusinessUnits($input: UpdateAccountMemberBusinessUnitsInput!) {
    updateAccountMemberBusinessUnits(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
